// utils/dateHelpers.ts

/**
 * Parses a backend date string (with or without time/offset)
 * and returns a Date object in local time at midnight.
 *
 * Example:
 *   "1990-03-14T05:00:00Z" -> Wed Mar 14 1990 00:00:00 (local)
 *   "2025-09-26T12:15:43-05:00" -> Fri Sep 26 2025 00:00:00 (local)
 */

export function dateWithoutTimeOffset(date: string): string {
  if (!date) {
    throw new Error('dateWithoutTimeOffset expects a Date object or string');
  }

  const dateOnly = date.split('T')[0];
  return `${dateOnly}T00:00:00`;
}
